import { Select } from "antd";
import React from "react";
import "./DefaultSelect.css";

interface IOptionList {
	value: any;
	label: any;
}

interface IDefaultSelect {
	label?: string;
	value?: any;
	placeholder?: string;
	width?: number;
	allowClear?: boolean;
	labelInValue?: boolean;
	options?: IOptionList[];
	onChange?: (value: any) => void;
	flexDirection?: "row" | "col";
	alignCenter?: "center" | "start";
	className?: any;
	status?: any;
	style?: React.CSSProperties;
	onClear?: () => void;
	onSelect?: (value: any, option: IOptionList | IOptionList[]) => void; // Updated onSelect signature
	disabled?: boolean;
	onSearch?: any;
	mode?: any;
}

const DefaultSelect = ({
	label,
	placeholder,
	value,
	width,
	options,
	onChange,
	flexDirection = "row",
	alignCenter = "center",
	className,
	onClear,
	allowClear,
	labelInValue = false,
	status,
	style,
	disabled,
	onSearch,
	mode,
}: IDefaultSelect) => {
	const filterOption = (
		input: string,
		option?: { label: string; value: string }
	) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	return (
		<div
			className={`flex flex-${flexDirection} items-${alignCenter} gap-1 `}
		>
			<label className="-mb-1">{label}</label>
			<Select
				labelInValue={labelInValue}
				showSearch
				allowClear={allowClear}
				placeholder={placeholder}
				options={options}
				onChange={onChange}
				value={value}
				className={`default-select ${className}`}
				onClear={onClear}
				status={status}
				style={style}
				filterOption={filterOption}
				disabled={disabled}
				onSearch={onSearch}
				mode={mode}
				maxTagCount="responsive"
			/>
		</div>
	);
};

export default DefaultSelect;
